import { v4 as uuidv4 } from 'uuid';

import { IKnmJudgmentSubjectData } from '../../../APIPackage/KnmModule/interfaces/IKnmJudgmentSubjectData';
import { IKnmJudgmentAgainstInfo } from '../../../APIPackage/KnmModule/interfaces/IKnmJudgmentAgainstInfo';
import { IKnmJudgmentActOrDecision } from '../../../APIPackage/KnmModule/interfaces/IKnmJudgmentActOrDecision';
import { IKnmErknmFormJudgmentSubjectData } from '../interfaces/IKnmErknmFormJudgmentSubjectData';

export const convertJudgmentSubjectFormValuesToKnmData = (
  formSubjects: IKnmErknmFormJudgmentSubjectData[],
  isDraft?: boolean,
): IKnmJudgmentSubjectData[] | null => {
  return formSubjects.map(formSubjectData => {
    const subjectData: IKnmJudgmentSubjectData = {
      ...formSubjectData,
      organizationGuid: formSubjectData.organizationGuid || null,
      judgmentAgainstOrganizations: formSubjectData.judgmentAgainstOrganizations
        ? {
            guid: formSubjectData.judgmentAgainstOrganizations.guid || uuidv4(),
            officialPersonFio: null,
            officialPersonJobTitle: null,
            prosecutionType: formSubjectData.judgmentAgainstOrganizations.prosecutionType || null,
            punishmentType: formSubjectData.judgmentAgainstOrganizations.punishmentType || null,
            amountOfPunishment: formSubjectData.judgmentAgainstOrganizations.amountOfPunishment || null,
            punishmentIndex: formSubjectData.judgmentAgainstOrganizations.punishmentIndex || null,
            punishmentNoteLawsuits: formSubjectData.judgmentAgainstOrganizations.punishmentNoteLawsuits || null,
            cancellationInformation: formSubjectData.judgmentAgainstOrganizations.cancellationInformation || null,
            explanation: formSubjectData.judgmentAgainstOrganizations.explanation || null,
          }
        : null,
      judgmentAgainstOfficialPerson:
        formSubjectData.judgmentAgainstOfficialPerson?.map(formOfficialPerson => {
          const officialPerson: IKnmJudgmentAgainstInfo = {
            ...formOfficialPerson,
            isNew: isDraft ? formOfficialPerson.isNew : null,
            guid: formOfficialPerson.guid || uuidv4(),
            officialPersonFio: formOfficialPerson.officialPersonFio || null,
            officialPersonJobTitle: formOfficialPerson.officialPersonJobTitle || null,
            prosecutionType: formOfficialPerson.prosecutionType || null,
            punishmentType: formOfficialPerson.punishmentType || null,
            amountOfPunishment: formOfficialPerson.amountOfPunishment || null,
            punishmentIndex: formOfficialPerson.punishmentIndex || null,
            punishmentNoteLawsuits: formOfficialPerson.punishmentNoteLawsuits || null,
            cancellationInformation: formOfficialPerson.cancellationInformation || null,
            explanation: formOfficialPerson.explanation || null,
          };

          return officialPerson;
        }) || null,
      cancellationActsAndDecisions:
        formSubjectData.cancellationActsAndDecisions?.map(formCancellation => {
          const cancellation: IKnmJudgmentActOrDecision = {
            ...formCancellation,
            actGuid: formCancellation.actGuid || null,
            decisionGuid: formCancellation.decisionGuid || null,
            cancellationInformation: formCancellation.cancellationInformation || null,
            newCancellationInformation: formCancellation.newCancellationInformation || null,
            explanation: formCancellation.explanation || null,
            newExplanation: formCancellation.newExplanation || null,
          };

          return cancellation;
        }) || null,
    };

    return subjectData;
  });
};
